export default {
  namespace: true,
  strict: true,
  state: {
    loading: false,
    uploading: false,
    data: [],
    progress: 0,
    file: null,
  },
  mutations: {
    SET_LOADING: (state, bool) => {
      state.loading = bool;
    },
    SET_MEDIA: (state, data) => {
      state.data = data;
    },
    SET_MEDIA_UPLOADING: (state, bool) => {
      state.uploading = bool;
    },
    SET_MEDIA_FILE: (state, file) => {
      state.file = file;
    },
    SET_MEDIA_UPLOAD_PROGRESS: (state, progress) => {
      state.progress = progress;
    },
  },
  actions: {
    getMedia({ commit }, id) {
      commit("SET_LOADING", true);
      this.$http.get(`vendors/${id}/media`).then((res) => {
        if (res.status == 200) {
          commit("SET_MEDIA", res.data.data);
          commit("SET_LOADING", false);
        }
      });
    },
    uploadMedia: function ({ commit, dispatch }, payload) {
      commit("SET_MEDIA_FILE", payload.file);
      commit("SET_MEDIA_UPLOADING", true);

      let formData = new FormData();
      formData.append("image", payload.file, payload.file.name);
      this.$http
        .post(`vendors/${payload.vendor.id}/media/upload`, formData, {
          onUploadProgress: (uploadEvent) => {
            let progress = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
            commit("SET_MEDIA_UPLOAD_PROGRESS", progress);
          },
        })
        .then((res) => {
          commit("SET_UPLOAD_PROGRESS", res.data.message);
          commit("SET_MEDIA_FILE", null);
          commit("SET_MEDIA_UPLOADING", false);
          dispatch("getMedia", payload.vendor.id);
        })
        .catch(() => {
          commit("SET_MEDIA_FILE", null);
          commit("SET_MEDIA_UPLOADING", false);
          dispatch(
            "setError",
            {
              message: "Image size is too large, please use smaller one.",
              code: 1,
            },
            { root: true }
          );
        });
    },
    deleteMedia: function ({ state }, payload) {
      this.$http
        .delete(`vendors/${payload.id}/media/${payload.mid}`)
        .then(function (res) {
          if (res.status == 200) {
            state.data = state.data.filter((item) => {
              if (item.id == payload.mid) {
                return false;
              }
              return true;
            });
          }
        });
    },
  },
};
